import React, { useEffect, useState } from 'react';
import { getDownloadURL, listAll, ref } from 'firebase/storage';
import { storage } from '../../firebase';
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { useUserPermissions } from "../../Hooks/GetUserPermissions";
import GetUserData from '../../Hooks/GetUserData';

const ImageViewer = () => {
  const [allImageUrls, setAllImageUrls] = useState([]);
  const [imageRefs, setImageRefs] = useState([]);
  const [selectedIndexes, setSelectedIndexes] = useState([]);
  const [layoutMode, setLayoutMode] = useState('grid');
  const [imageSelectLabel, setImageSelectLabel] = useState('Selecciona una imagen:');

  const { hubId } = useParams();
  const navigate = useNavigate();

  const { loading, userData } = GetUserData();
  const { loadingPermisos, permisos } = useUserPermissions();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const folderPath = `${hubId}/dashboard-data/`;
        const folderRef = ref(storage, folderPath);
        const result = await listAll(folderRef);

        setImageRefs(result.items);

        const urls = await Promise.all(
          result.items.map((itemRef) => getDownloadURL(itemRef))
        );
        setAllImageUrls(urls);

        const initialSelected = urls.slice(0, 4).map((_, index) => index);
        setSelectedIndexes(initialSelected);

        const configRef = doc(db, 'private-hubs', hubId);
        const configSnap = await getDoc(configRef);

        if (configSnap.exists()) {
          const configData = configSnap.data();
          setLayoutMode(configData.layoutMode || 'grid');
          if (configData.dashboardImgLabel) {
            setImageSelectLabel(configData.dashboardImgLabel);
          }
        }
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    };

    fetchData();
  }, [hubId]);

  const handleChange = (blockIndex, selectedIndex) => {
    if (permisos?.verDashboard !== 'lectura_escritura') return;

    const newSelections = [...selectedIndexes];
    newSelections[blockIndex] = parseInt(selectedIndex, 10);
    setSelectedIndexes(newSelections);
  };

  if (loadingPermisos) return null;

  const canEdit = permisos?.verDashboard === 'lectura_escritura';

  return (
    <div>
      {layoutMode === 'grid' ? (
        <div className="dashboard-grid">
          {selectedIndexes.slice(0, 4).map((selectedIdx, i) => (
            <div key={i} className="dashboard-column">

              {canEdit && (
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    marginBottom: '10px',
                    flexWrap: 'wrap'
                  }}
                >
                  <h3 className='labelText' style={{ margin: 0 }}>
                    {imageSelectLabel}
                  </h3>

                  <select
                    className='labelText'
                    value={selectedIdx}
                    onChange={(e) => handleChange(i, e.target.value)}
                    style={{
                      padding: '6px',
                      borderRadius: '6px',
                      fontSize: '18px',
                      fontWeight: '300'
                    }}
                  >
                    {imageRefs.map((refItem, idx) => (
                      <option key={idx} value={idx}>
                        {refItem.name.replace(/\.[^/.]+$/, "")}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <img
                src={allImageUrls[selectedIdx]}
                alt={`Imagen seleccionada ${selectedIdx + 1}`}
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <div>
          {selectedIndexes.slice(0, 1).map((selectedIdx, i) => (
            <div key={i} className="dashboard-column">

              {canEdit && (
                <div
                  style={{
                    display: 'flex',
                    gap: '12px',
                    marginBottom: '10px',
                    flexWrap: 'wrap'
                  }}
                >
                  <h3 className='labelText' style={{ margin: 0 }}>
                    {imageSelectLabel}
                  </h3>

                  <select
                    className='labelText'
                    value={selectedIdx}
                    onChange={(e) => handleChange(i, e.target.value)}
                    style={{
                      padding: '6px',
                      borderRadius: '6px',
                      fontSize: '18px',
                      fontWeight: '300'
                    }}
                  >
                    {imageRefs.map((refItem, idx) => (
                      <option key={idx} value={idx}>
                        {refItem.name.replace(/\.[^/.]+$/, "")}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <img
                src={allImageUrls[selectedIdx]}
                alt={`Imagen seleccionada ${selectedIdx + 1}`}
                style={{
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              />
            </div>
          ))}
        </div>
      )}

      <div style={{ marginBottom: '20px' }}>
        {!loading && userData.hubId.includes("__superadmin__") && (
          <button
            onClick={() => navigate(`/lobby/${hubId}/editor`)}
            className='seccion-btn'
          >
            Editar
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageViewer;